import React, { useEffect, useState } from "react";
import { Link, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { signout } from "../actions/userActions";
import SearchBox from "./searchBox";
import { listProductCategories } from "../actions/productActions";
import LoadingBox from "./loadingBox";
import MessageBox from "./messageBox";

function NavBar(props) {
  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;

  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo } = userSignin;

  const dispatch = useDispatch();
  const signoutHandler = () => {
    dispatch(signout());
    //after signout, auto refresh page
    window.location.reload();
  };

  const productCategoryList = useSelector((state) => state.productCategoryList);
  const {
    loading: loadingCategories,
    error: errorCategories,
    categories,
  } = productCategoryList;
  useEffect(() => {
    dispatch(listProductCategories());
  }, [dispatch]);

  return (
    <div className="sticky-top">
      {/* navbar */}
      <nav className="navbar bg-dark ">
        <div className="container-fluid pt-1 pb-1">
          <div className="col-lg-3 col-md-3 col-sm-3 mb-1 ">
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar"
            >
              <span className="navbar-dark navbar-toggler-icon"></span>
            </button>
            <Link className="navbar-brand  logo_name " to="/">
              Amason
            </Link>
          </div>

          <div className="col-12 col-md-5 pb-1">
            <Route
              render={({ history }) => (
                <SearchBox history={history}></SearchBox>
              )}
            ></Route>
          </div>

          <div className="col-lg-2 col-md-2 col-sm-2">
            <div className="d-flex position-absolute top-0 end-0 nav_links">
              <Link to="/cart" className="nav-link p-2 text-light link-light">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  fill="currentColor"
                  className="bi bi-cart2"
                  viewBox="0 0 16 16"
                >
                  <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z" />
                </svg>
                {cartItems.length > 0 && (
                  <span className="badge bg-danger">{cartItems.length}</span>
                )}
              </Link>
              {userInfo ? (
                <div className="dropdown d-flex align-items-center signout">
                  <Link
                    to="/profile"
                    className="dropdown-toggle text-decoration-none  text-white "
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {userInfo.name}
                  </Link>
                  <ul className="dropdown-menu text-center ">
                    <li>
                      <Link
                        to="/profile"
                        className="text-decoration-none text-black "
                      >
                        Profile
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/orderhistory"
                        className="text-decoration-none text-black "
                      >
                        Order Hist
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#signout"
                        className="text-decoration-none text-black"
                        onClick={signoutHandler}
                      >
                        Sign Out
                      </Link>
                    </li>
                  </ul>
                </div>
              ) : (
                <Link to="/signin" className="nav-link p-2 text-light">
                  Login
                </Link>
              )}
              {userInfo && userInfo.isAdmin && (
                <div className="dropdown d-flex align-items-center admin_signout">
                  <Link
                    to="#admin"
                    className="dropdown-toggle text-decoration-none  text-white "
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Admin
                  </Link>
                  <ul className="dropdown-menu text-center">
                    <li>
                      <Link
                        to="/dashboard"
                        className="text-decoration-none text-black "
                      >
                        Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/productlist"
                        className="text-decoration-none text-black "
                      >
                        Products
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/orderlist"
                        className="text-decoration-none text-black "
                      >
                        Orders
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/userlist"
                        className="text-decoration-none text-black "
                      >
                        Users
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>

          <div
            className="offcanvas offcanvas-start sidebar"
            tabIndex="-1"
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
          >
            <div className="offcanvas-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body">
              <h6
                className="offcanvas-title fw-bold mb-3"
                id="offcanvasNavbarLabel"
              >
                Categories
              </h6>
              <ul
                className="navbar-nav justify-content-end flex-grow-1 pe-3 side_cat"
                data-bs-dismiss="offcanvas"
              >
                <li>
                  <Link
                    to="/search/name"
                    className="link-secondary nav-link-side text-decoration-none  "
                  >
                    All
                  </Link>
                </li>
                {loadingCategories ? (
                  <LoadingBox></LoadingBox>
                ) : errorCategories ? (
                  <MessageBox variant="danger">{errorCategories}</MessageBox>
                ) : (
                  categories.map((c) => (
                    <li key={c}>
                      <Link
                        className="link-secondary nav-link-side text-decoration-none "
                        to={`/search/category/${c}`}
                      >
                        {c}
                      </Link>
                    </li>
                  ))
                )}
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default NavBar;

// function NavBar(props) {
//   const cart = useSelector((state) => state.cart);
//   const { cartItems } = cart;

//   const userSignin = useSelector((state) => state.userSignin);
//   const { userInfo } = userSignin;

//   const dispatch = useDispatch();
//   const signoutHandler = () => {
//     dispatch(signout());
//     //after signout, auto refresh page
//     window.location.reload();
//   };

//   const productCategoryList = useSelector((state) => state.productCategoryList);
//   const {
//     loading: loadingCategories,
//     error: errorCategories,
//     categories,
//   } = productCategoryList;
//   useEffect(() => {
//     dispatch(listProductCategories());
//   }, [dispatch]);

//   return (
//     <div className="">
//       {/* navbar */}
//       <nav className="navbar bg-dark">
//         <div className="container-fluid pt-1 pb-1">
//           <div className="col-lg-3 col-md-3 col-sm-3 mb-1 ">
//             <button
//               className="navbar-toggler"
//               type="button"
//               data-bs-toggle="offcanvas"
//               data-bs-target="#offcanvasNavbar"
//               aria-controls="offcanvasNavbar"
//             >
//               <span className="navbar-dark navbar-toggler-icon"></span>
//             </button>
//             <Link className="navbar-brand  logo_name " to="/">
//               Amason
//             </Link>
//           </div>

//           <div className="col-lg-6 col-md-6 col-sm-6">
//             <Route
//               render={({ history }) => (
//                 <SearchBox history={history}></SearchBox>
//               )}
//             ></Route>
//           </div>

//           <div className="col-lg-2 col-md-2 col-sm-2">
//             <div className="d-flex position-absolute top-0 end-0 nav_links">
//               <Link to="/cart" className="nav-link p-2 text-light ">
//                 Cart
//                 {cartItems.length > 0 && (
//                   <span className="badge bg-danger">{cartItems.length}</span>
//                 )}
//               </Link>
//               {userInfo ? (
//                 <div className="dropdown d-flex align-items-center signout">
//                   <Link
//                     to="/profile"
//                     className="dropdown-toggle text-decoration-none  text-white "
//                     role="button"
//                     data-bs-toggle="dropdown"
//                     aria-expanded="false"
//                   >
//                     {userInfo.name}
//                   </Link>
//                   <ul className="dropdown-menu text-center ">
//                     <li>
//                       <Link
//                         to="/profile"
//                         className="text-decoration-none text-black "
//                       >
//                         Profile
//                       </Link>
//                     </li>
//                     <li>
//                       <Link
//                         to="/orderhistory"
//                         className="text-decoration-none text-black "
//                       >
//                         Order Hist
//                       </Link>
//                     </li>
//                     <li>
//                       <Link
//                         to="#signout"
//                         className="text-decoration-none text-black"
//                         onClick={signoutHandler}
//                       >
//                         Sign Out
//                       </Link>
//                     </li>
//                   </ul>
//                 </div>
//               ) : (
//                 <Link to="/signin" className="nav-link p-2 text-light">
//                   Sign In
//                 </Link>
//               )}
//               {userInfo && userInfo.isAdmin && (
//                 <div className="dropdown d-flex align-items-center admin_signout">
//                   <Link
//                     to="#admin"
//                     className="dropdown-toggle text-decoration-none  text-white "
//                     role="button"
//                     data-bs-toggle="dropdown"
//                     aria-expanded="false"
//                   >
//                     Admin
//                   </Link>
//                   <ul className="dropdown-menu text-center">
//                     <li>
//                       <Link
//                         to="/dashboard"
//                         className="text-decoration-none text-black "
//                       >
//                         Dashboard
//                       </Link>
//                     </li>
//                     <li>
//                       <Link
//                         to="/productlist"
//                         className="text-decoration-none text-black "
//                       >
//                         Products
//                       </Link>
//                     </li>
//                     <li>
//                       <Link
//                         to="/orderlist"
//                         className="text-decoration-none text-black "
//                       >
//                         Orders
//                       </Link>
//                     </li>
//                     <li>
//                       <Link
//                         to="/userlist"
//                         className="text-decoration-none text-black "
//                       >
//                         Users
//                       </Link>
//                     </li>
//                   </ul>
//                 </div>
//               )}
//             </div>
//           </div>

//           <div
//             className="offcanvas offcanvas-start sidebar"
//             tabIndex="-1"
//             id="offcanvasNavbar"
//             aria-labelledby="offcanvasNavbarLabel"
//           >
//             <div className="offcanvas-header">
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="offcanvas"
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="offcanvas-body">
//               <h6
//                 className="offcanvas-title fw-bold mb-3"
//                 id="offcanvasNavbarLabel"
//               >
//                 Categories
//               </h6>
//               <ul
//                 className="navbar-nav justify-content-end flex-grow-1 pe-3 side_cat"
//                 data-bs-dismiss="offcanvas"
//               >
//                 <li>
//                   <Link
//                     to="/search/name"
//                     className="link-secondary nav-link-side text-decoration-none  "
//                   >
//                     All
//                   </Link>
//                 </li>
//                 {loadingCategories ? (
//                   <LoadingBox></LoadingBox>
//                 ) : errorCategories ? (
//                   <MessageBox variant="danger">{errorCategories}</MessageBox>
//                 ) : (
//                   categories.map((c) => (
//                     <li key={c}>
//                       <Link
//                         className="link-secondary nav-link-side text-decoration-none "
//                         to={`/search/category/${c}`}
//                       >
//                         {c}
//                       </Link>
//                     </li>
//                   ))
//                 )}
//               </ul>
//             </div>
//           </div>
//         </div>
//       </nav>
//     </div>
//   );
// }

// export default NavBar;
